module.exports = __webpack_public_path__ + "img/29a)Hofgarten.jpg";